import { defineMessages } from 'react-intl';

const messages = defineMessages({
  iconsText: {
    id: 'iconsText',
    defaultMessage: 'Ikonoa',
  },
  anchorLink: {
    id: 'anchorLink',
    defaultMessage: 'Orrialde bereko esteka (aingura).',
  },
  anchorLinkDescription: {
    id: 'anchorLinkDescription',
    defaultMessage: 'Idatzi # karaktere eta guzti.',
  },
});

export const buttonSchemaEnhancer = (props) => {
  const { intl, schema } = props;

  return {
    ...schema,
    fieldsets: [
      {
        ...schema.fieldsets[0],
        fields: [...schema.fieldsets[0].fields, 'icon', 'anchor'],
      },
    ],
    properties: {
      ...schema.properties,
      icon: {
        title: intl.formatMessage(messages.iconsText),
        type: 'string',
        widget: 'select',
        choices: [
          ['icon-right', 'icon-right'],
          ['icon-down', 'icon-down'],
          ['icon-download', 'icon-download'],
        ],
      },
      anchor: {
        title: intl.formatMessage(messages.anchorLink),
        description: intl.formatMessage(messages.anchorLinkDescription),
      },
    },
    // required: [],
  };
};
